<template>
  <div class="exchanges-overview">
    <div class="exchanges-overview__header">
      <div class="exchanges-overview__header__title"> Binance overview </div>
      <div @click="$emit('force-refresh')" title="Refresh Data" class="exchanges-overview__header__refresh">
        <img src="@/assets/images/svg/refresh.svg" />
      </div>
    </div>

    <div class="exchanges-overview__infos">
      <div class="exchanges-overview__infos__total">
        <h2>Total balance </h2>
        <div v-for="(holding, index) in totalHoldings" :key="index">
          {{ COIN_CURRENCY[holding.coin] }} {{ holding.value }}
        </div>
      </div>

      <div class="exchanges-overview__infos__trade">
        <BaseSwitch disabled label="All Strategies" title="Update Trading Binance status" />
        <BaseButton label="Trade"
                    :title="`By using the Trade button, you can manually trigger the execution of Protos Strategy.
  The Protos Strategy automatically executes once a week to keep trading fees at a minimum.
  Please be aware that each manual trade execution produces trading fees!`"
                    @click.stop="$emit('trade-force-refresh')"
        />
      </div>

    </div>

  </div>
</template>

<script>
import { COIN_CURRENCY } from "@/constants/common";
import BaseSwitch from "@/components/ui/atoms/BaseSwitch";
import BaseButton from "@/components/ui/atoms/BaseButton";

export default {
  name: "ExchangesOverview",
  components: { BaseButton, BaseSwitch },
  props: {
    assetOverview: {
      type: Object,
      default() {
        return {};
      },
    },
    totalHoldings: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      COIN_CURRENCY,
      binanceTradingStatus: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.exchanges-overview {
  &__header {
    display: flex;
    justify-content: space-between;

    &__title {
      font-weight: 600;
      text-align: left;
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
    }

    &__refresh {
      cursor: pointer;
    }
  }

  &__infos {
    display: flex;
    justify-content: space-between;

    &__total {
      h2 {
        margin: 0 0 0.5rem 0;
        text-align: left;
      }

      div {
        text-align: left;
        font-size: 1.125rem;
      }

      div:not(:last-child) {
        margin-bottom: 0.5rem;
        font-weight: 600;
      }

      div:last-child {
        &:before {
          content: '(';
        }
        &:after {
          content: ')';
        }
      }
    }

    &__trade {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: space-between;

      button {
        width: 8rem;
        height: 2.5rem;
        line-height: 1.5rem;
        margin-top: 0.5rem;
      }
    }
  }
}

// only mobile
@media (max-width: 768px) {
  .exchanges-overview {
    &__infos {
      display: block;

      &__cards {
        justify-content: flex-start;
        gap: 0;

        &__card {
          &:not(:last-child) {
            margin: 0 2rem 2rem 0;
          }
        }
      }

      &__trade {
        align-items: center;
      }
    }
  }
}
</style>
